import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import Button from 'shared/components/Button';
import CheckBox from 'shared/components/CheckBox';
import { TimesIcon } from 'shared/components/Icons';
import { useSelector } from 'react-redux';
import Input from 'shared/components/Input';
import { getProjects } from 'app/routes/Dashboard/actions/projects';
import { copyObject } from 'utils/appHelpers';
// import PriceRange from './PriceRange';
// import RadioBox from 'shared/components/RadioBox';

const FiltersMenu = ({
  onClose,
  filtersData,
  showProjects,
  filters,
  setFilters,
  onResetFilters,
  hasSelectedFilters,
}) => {
  const projectsObj = useSelector(state => state.projects);
  const projects = Object.values(projectsObj || {});
  const { t } = useTranslation();
  const [localFilters, setLocalFilters] = useState(copyObject(filters));

  // const onFilterAlertChange = bool => {
  //   setFilters({ ...filters, withPriceAlert: bool });
  // };

  // const onPriceFilterChange = prices => {
  //   const [minPrice, maxPrice] = prices;
  //   setLocalFilters({ ...localFilters, minPrice, maxPrice });
  // };

  const onPriceChange = e => {
    const { name, value } = e.target;
    setLocalFilters({ ...localFilters, [name]: value });
  };

  const onFormChange = (name, item) => {
    const tempFilter = { ...localFilters };
    const tempData = tempFilter[name];
    if (tempData.includes(item)) {
      tempData.splice(tempData.indexOf(item), 1);
    } else {
      tempData.push(item);
    }
    setLocalFilters(tempFilter);
  };

  const onSaveFilters = () => {
    setFilters(localFilters);
    onClose();
  };

  useEffect(() => {
    if (!projectsObj) getProjects();
  }, []);

  // const priceRangeValues = [
  //   localFilters.minPrice || filtersData?.minPrice,
  //   localFilters.maxPrice || filtersData?.maxPrice,
  // ];

  return (
    <div className='filters-menu pt-10 pt-md-27 pb-15 pl-8 pl-md-20 pr-5 pr-md-20 d-flex flex-column'>
      <button className='btn p-0 modal-close mt-md-15 mt-0' onClick={onClose}>
        <TimesIcon />
      </button>
      <h1 className='mb-10 mb-md-14'>{t('title_filter')}</h1>
      <div className='filters-content h-100'>
        <div>
          <h2 className='mb-8'>{t('filter_categories')}</h2>
          <CheckBoxGroup
            data={filtersData?.categories}
            name='categories'
            filters={localFilters}
            keyName={'key'}
            valueName={'key'}
            onChange={onFormChange}
            withTranslation
          />
        </div>
        {showProjects && (
          <div className='mt-7 mt-md-15'>
            <h2 className='mb-8'>{t('filter_projects')}</h2>
            <CheckBoxGroup
              data={projects}
              name='projects'
              filters={localFilters}
              keyName={'name'}
              valueName={'id'}
              onChange={onFormChange}
            />
          </div>
        )}
        <div className='mt-7 mt-md-15'>
          <h2 className='mb-8'>{t('filter_shop')}</h2>
          <CheckBoxGroup
            data={filtersData?.source}
            name='source'
            filters={localFilters}
            keyName={'key'}
            valueName={'key'}
            onChange={onFormChange}
          />
        </div>
        <div className='mt-7 mt-md-15'>
          <h2 className='mb-8'>{t('filter_brand')}</h2>
          <CheckBoxGroup
            data={filtersData?.brand}
            name='brands'
            filters={localFilters}
            keyName={'key'}
            valueName={'key'}
            onChange={onFormChange}
          />
        </div>

        <div className='mt-7 mt-md-15'>
          <h2 className='mb-4 mb-md-8'>{t('filter_price_range')}</h2>
          <div className='d-flex align-items-center'>
            <Input
              type='number'
              name='minPrice'
              onChange={onPriceChange}
              value={localFilters?.minPrice}
              placeholder={t('ph_from')}
              className='mb-0'
            />
            <div className='mx-10'>-</div>
            <Input
              type='number'
              name='maxPrice'
              onChange={onPriceChange}
              value={localFilters?.maxPrice}
              placeholder={t('ph_to')}
              className='mb-0'
            />
          </div>
          {/* <PriceRange
            min={filtersData?.minPrice - 1}
            max={filtersData?.maxPrice}
            values={priceRangeValues}
            onChange={onPriceFilterChange}
            step={1}
          /> */}
        </div>
        {/* <div className='mt-7 mt-md-15'>
          <h2 className='mb-8'>{t('filter_with_price_alert')}</h2>
          <div className='col-12 row'>
            <RadioBox
              checked={filters.withPriceAlert}
              id='radio1'
              name='yes'
              className='mb-md-5 mb-0 col-6 col-md-12'
              onChange={onFilterAlertChange.bind(null, true)}
              label={t('text_yes')}
            />
            <RadioBox
              checked={!filters.withPriceAlert}
              id='radio2'
              name='no'
              className='col-6 col-md-12'
              onChange={onFilterAlertChange.bind(null, false)}
              label={t('text_no')}
            />
          </div>
        </div> */}
        <div className='mt-12 mt-mt-10'>
          <Button onClick={onSaveFilters} className='btn btn-sm btn-primary'>
            {t('btn_save')}
          </Button>
          <Button
            disabled={!hasSelectedFilters}
            onClick={onResetFilters}
            className='btn btn-sm btn-outline-primary ml-10'
          >
            {t('btn_reset')}
          </Button>
          <Button onClick={onClose} className='btn btn-sm btn-outline-primary ml-10'>
            {t('btn_cancel')}
          </Button>
        </div>
      </div>
    </div>
  );
};

const CheckBoxGroup = ({ data, keyName, valueName, name, filters, onChange, withTranslation }) => {
  const { t } = useTranslation();
  return (
    <div className='row col-12'>
      {data &&
        data.map((item, i) => {
          const label = withTranslation ? t(item[keyName]) : item[keyName];
          return (
            <CheckBox
              key={i}
              className='mb-md-8 mb-7 col-6 col-md-12'
              label={label}
              id={`${name}${item[valueName]}`}
              name={`${name}${item[valueName]}`}
              checked={filters[name].includes(item[valueName])}
              onChange={onChange.bind(null, name, item[valueName])}
            />
          );
        })}
    </div>
  );
};

export default FiltersMenu;
